import {
    FETCH_WASTE_CATEGORY_REQUEST,
    FETCH_WASTE_CATEGORY_SUCCESS,
    FETCH_WASTE_CATEGORY_FALUIRE,
} from './wasteCategoryTypes'

const initialState = {
    loading: false,
    allWasteCategory: null,
    error: '',
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_WASTE_CATEGORY_REQUEST: return {
            ...state,
            loading: true,

        }

        case FETCH_WASTE_CATEGORY_SUCCESS: return {
            ...state,
            allWasteCategory: action.payload,
            error: '',
            loading: false,
        }

        case FETCH_WASTE_CATEGORY_FALUIRE: return {
            ...state,
            loading: false,
            allWasteCategory: null,
            error: action.payload,
        }

        default: return state

    }
}

export default reducer
